export const CLOSE_MODAL_MESSAGE = 'app/CLOSE_MODAL_MESSAGE';
export const OPEN_MODAL = 'app/OPEN_MODAL';
export const OPEN_MODAL_MESSAGE = 'app/OPEN_MODAL_MESSAGE';
export const RESET_APP = 'app/RESET_APP';
export const RE_AUTH = 'app/RE_AUTH';
export const SET_APP_VERSION = 'app/SET_APP_VERSION';
export const SET_DOCUMENT_MODE = 'app/SET_DOCUMENT_MODE';
